import GenderIcon from './GenderIcon'

export default GenderIcon
